export default __webpack_public_path__ + "static/air_compressor_b.df9566807466ae9ef7fa81d397cce630.svg";